import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.authentication-policies', {
        url: '/authentication-policies',
        component: 'companyManageApplicationAuthenticationPolicies',
        resolve: {currentPasswordAuthenticationSettings,authenticationAccessPolicyList},
    });
}
/** @ngInject */
function currentPasswordAuthenticationSettings(companyId,application,AuthenticationPoliciesService) {
    return AuthenticationPoliciesService.GetCurrentPasswordAuthenticationSettings(companyId,application.id);
}
/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    const type='basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId,type);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/authentication-policies.state.js